type CopilotStateListener = (isThinking: boolean) => void;

class CopilotStateManager {
  private isThinking: boolean = false;
  private listeners: Set<CopilotStateListener> = new Set();

  setThinking(thinking: boolean) {
    if (this.isThinking !== thinking) {
      this.isThinking = thinking;
      this.notifyListeners();
    }
  }

  isThinkingState() {
    return this.isThinking;
  }

  subscribe(listener: CopilotStateListener) {
    this.listeners.add(listener);
    // Notify immediately of current state
    listener(this.isThinking);

    // Return unsubscribe function
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener(this.isThinking));
  }
}

export const copilotState = new CopilotStateManager();
